export default "__VITE_ASSET__2DNuu1fk__"